import React from 'react';
import './scss//BouncingDots.scss';

const BouncingDots = ({ size = 7, color = 'var(--brand-color)' }) => {
    const dotStyle = {
        width: `${size}px`,
        height: `${size}px`,
        background: color,
    };

    return (
        <div className="bouncing-dots">
            <span style={dotStyle}></span>
            <span style={dotStyle}></span>
            <span style={dotStyle}></span>
        </div>
    );
};

export default BouncingDots;